<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2">
            <bita-bootbutton
              v-if="!showForm"
              type="primary"
              title="مشتری جدید"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="statusChangeModalCreate"
            />
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :cities-data="cities"
      modal-id="edit-modal"
      title="ویرایش مشتری"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      modal-id="create-modal"
      title="مشتری جدید"
      @on-submit="handleCreate"
    />
    <view-modal
      modal-id="view-modal"
      title="مشخصات مشتری"
      :props-data="updateForm"
    />
  </div>
</template>
<script>
import CustomersForm from "./From";
import CustomersView from "./View";

export default {
  components: { "form-modal": CustomersForm, "view-modal": CustomersView },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/",
        },
        {
          title: "مدیریت مشتری ها",
          link: "/management/customers",
          active: true,
        },
      ],

      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,

      createForm: {},
      updateForm: {},
      cities: [],

      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام",  width: "100px" },
        { field: "family", title: "نام خانوادگی",  width: "100px" },
        { field: "national_code", title: "کد ملی",  width: "100px" },
        { field: "phone", title: "شماره تماس",  width: "100px" },
        {
          field: "type",
          title: "نوع",
          template: (e) => (e.type == 1 ? "حقیقی" : "حقوقی"),
           width: "100px"
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
             width: "100px"
        },
        {
          title: "عملیات",
          command: [],
           width: "100px"
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      this.$persistClient("get", "customers?include=city")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      this.$toggleModal("#edit-modal");
      // $("#edit-modal")
      //   .modal({
      //     backdrop: "static",
      //     keyboard: false,
      //   })
      //   .modal("toggle");
    },
    statusChangeModalCreate() {
      this.$toggleModal("#create-modal");
      // $("#create-modal")
      //   .modal({
      //     backdrop: "static",
      //     keyboard: false,
      //   })
      //   .modal("toggle");
    },
    statusChangeModalView() {
      this.$toggleModal("#view-modal");
    },
    gridCommands() {
      let commands = [];
      // commands.push({
      //   text: "view",
      //   click: this.view,
      //   template: this.gridButtons.view,
      // });
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    edit(e) {
      let customer = this.$refs.grid.getSelectedGridRow(e);
      this.isLoadingGrid = true;
      var _this = this;
      this.getCities(customer.city.parent_id).then((res) => {
        this.cities = res.data;

        setTimeout(function() {
          _this.updateForm = {
            id: customer.id,
            name: customer.name,
            family: customer.family,
            national_code: customer.national_code,
            phone: customer.phone,
            postal_code: customer.postal_code,
            address: customer.address,
            city_id: customer.city.id,
            city: customer.city.name,
            state_id: customer.city.province.id,
            state: customer.city.province.name,
          };
          _this.statusChangeModalEdit();
          _this.isLoadingGrid = false;
        }, 500);
      });
    },
    delete(e) {
      let customer = this.$refs.grid.getSelectedGridRow(e);

      this.$alert(
        "question",
        `آیا از حذف ${customer.name} ${customer.family || ""} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `customers/${customer.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "customers", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);

          this.loadData();
          this.$refs.createModal.reset();

          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `customers/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {};

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    getCities(_provinceID) {
      return this.$persistClient(
        "get",
        `cities?filter[province]=${_provinceID}`
      );
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
